import { Input, Modal } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { DamageNumberText } from 'components/data/helpers';

const StyledInput = styled(Input)`
  margin-top: 1rem;
  width: 3rem;
  text-transform: uppercase;
  font-family: monospace;
`;

const StyledWarning = styled.div`
  font-size: 1.1rem;
`;

export function DeleteDamageModal({
  forceIdCheck = true,
  visible,
  disabled,
  damageNumber,
  isDeleting,
  onDelete,
  onChange,
  onCancel,
}) {
  const { t } = useTranslation();
  return forceIdCheck ? (
    <Modal
      open={visible}
      destroyOnHidden
      title={t('damage.deleteDamageQuestion', 'Delete Damage?')}
      okType="danger"
      okText={t('common.delete', 'Delete')}
      cancelText={t('common.cancel', 'Cancel')}
      onCancel={onCancel}
      onOk={onDelete}
      confirmLoading={isDeleting}
      okButtonProps={{ disabled, id: 'delete-damage-confirm-button' }}
      cancelButtonProps={{ id: 'delete-damage-cancel-button' }}
    >
      <StyledWarning style={{ marginBottom: '1rem' }}>
        <Trans
          i18nKey="damage.deleteDamageWarningWithConfirm"
          t={t}
          values={{ damageNumber }}
          components={{
            strong: <strong />,
            damageNumberText: <DamageNumberText />,
          }}
          defaults="Deleting a Damage <strong>cannot</strong> be undone. This will permanently delete Damage <strong><damageNumberText>{{damageNumber}}</damageNumberText></strong>. Please type the Damage number to confirm."
        />
      </StyledWarning>

      <StyledInput
        id="delete-damage-input"
        placeholder={t('table.damageId', 'Damage ID')}
        size="large"
        onChange={onChange}
        onPressEnter={onDelete}
        onPaste={(e) => {
          e.preventDefault();
        }}
      />
    </Modal>
  ) : (
    <Modal
      open={visible}
      destroyOnHidden
      title={t('damage.deleteDamageQuestion', 'Delete Damage?')}
      okType="danger"
      okText={t('common.delete', 'Delete')}
      cancelText={t('common.cancel', 'Cancel')}
      onCancel={onCancel}
      onOk={onDelete}
      confirmLoading={isDeleting}
      okButtonProps={{ id: 'quick-delete-damage-confirm-button' }}
      cancelButtonProps={{ id: 'quick-delete-damage-cancel-button' }}
    >
      <StyledWarning style={{ marginBottom: '1rem' }}>
        <Trans
          i18nKey="damage.deleteDamageWarning"
          t={t}
          values={{ damageNumber }}
          components={{
            strong: <strong />,
            damageNumberText: <DamageNumberText />,
          }}
          defaults="Deleting a Damage <strong>cannot</strong> be undone. This will permanently delete Damage <strong><damageNumberText>{{damageNumber}}</damageNumberText></strong>. "
        />
      </StyledWarning>
    </Modal>
  );
}
